export const GET_ALL_CHATS = "/livechat/resolvedChatData"
export const JOIN_LIVE_CHAT_ROOM = "/joinChatRoom"
